<template>
<div class="chapter">
<div class="inner_page">
<p class="ct1"><b>PART I</b><br/>
<br/>
<span class="small"><i>C</i><i><span class="small"><span class="small">OUNTRY</span></span></i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Alle_9781617750601_epub_c9_r1.vue?5d6528b4